import {useZero} from '@/shared/integrations/zero/use-zero'
import {UpdateResourceStatusSchema} from '@cypro/engine/mutators/util'
import {useCallback} from 'react'

export function useUpdateSolutionDrugStatus() {
  const zero = useZero()

  return useCallback(
    (payload: UpdateResourceStatusSchema) =>
      zero.attemptMutation(zero.mutators.solutions.updateStatus(payload), async mutation => await mutation.server),
    [zero]
  )
}
